var activityEvents, script_loaded = false;

if (typeof __isPSA === 'undefined') var __isPSA = false;

if (typeof uLTS === 'undefined') {
    var uLTS = new MutationObserver(function() {});
    uLTS.observe(document.documentElement, { childList: true, subtree: true });
}

function loadJSscripts() {
    if (script_loaded) return;

    if (typeof uLTS !== 'undefined') uLTS.disconnect();
    if (typeof window.yett !== 'undefined') window.yett.unblock();

    script_loaded = true;

    document.querySelectorAll("link[data-href]").forEach(function(e) {
        var datahref = e.dataset.href;
        if (datahref != null) e.href = datahref;
    });

    document.querySelectorAll("script[type='text/lazyload']").forEach(function(e) {
        var t = document.createElement("script");
        for (var a = 0; a < e.attributes.length; a++) {
            var r = e.attributes[a];
            t.setAttribute(r.name, r.value);
        }
        t.type = "text/javascript";
        t.innerHTML = e.innerHTML;
        e.parentNode.insertBefore(t, e);
        e.parentNode.removeChild(e);
    });

    document.dispatchEvent(new CustomEvent("asyncLazyLoad"));

    setTimeout(function() {
        document.dispatchEvent(new CustomEvent("loadBarInjector"));
    }, 1000);
}

if (__isPSA) {
    ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"].forEach(function(e) {
        window.addEventListener(e, loadJSscripts, false);
    });
} else {
    loadJSscripts();
}
